<template>
  <div class="mermber">
    <div class="main">
      <div class="member-bar-wrap">
        <Bar title="会员中心" class="member-bar" />
      </div>
      <img class="title_img" src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758182406528_94461.png" />
      <div class="content" :class="{short: sourceC == 'ios'}">
        <div class="content-user-wrap">
          <img class="content-user-img" :src="Info.headPhoto" />
          <div class="content-user-text">
            <p class="content-user-name">{{ Info.nickname }}</p>
            <p class="content-user-date">{{ Info.memberDesc }}</p>
          </div>
        </div>
        <div class="content-equity-wrap" @click="handleEquitPop(1)">
          <div class="content-equity-l">
            <img class="content-equity-img"
              src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758180834122_51750.png" />
            <p class="content-equity-text">APP+小程序 双重权益重磅来袭！</p>
          </div>
          <img class="content-equity-r"
            src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758180834122_89298.png" />
        </div>
        <div class="menu" v-if="!loading">
          <div v-for="(item, idx) of realPackageList" :key="idx" class="item-no" :class="{ item: idx == selectMenu }"
            @click="selectPackage(idx, item)">
            <div v-if="item.productDescKv.compareProduct.isShow" class="item-no-contenter item-no-contenter-desc8">
              <img class="bg"
              src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1765880646904_48183.png" />
              <div class="left">
                <div v-if="item.productDescKv.upperRightTag" class="tip-bg">{{ item.productDescKv.upperRightTag }}</div>
                <div class="text-doc">{{ item.title }}</div>
                <div>
                  <span class="price-icon">￥</span><span class="price">{{ getPrice(priceDown)}}</span>
                </div>
                <div v-if="item.awardId > 0 || +item.showOriginPrice === 1" class="second">
                  ￥{{ getPrice(item.originPrice) }}
                </div>
                <div class="item-nom">{{ item.productDescKv.bottomTag }}</div>
              </div>
              <div class="right">
                <div class="text-doc">原价{{ item.title }}</div>
                <div>
                  <span class="price-icon">￥</span><span class="price">{{ getPrice(item.productDescKv.compareProduct.price) }}</span>
                </div>
                <div v-if="item.awardId > 0 || +item.showOriginPrice === 1" class="second">
                  ￥{{ getPrice(item.originPrice) }}
                </div>
                <div class="item-nom">{{ item.productDescKv.compareProduct.bottomTag }}</div>
              </div>
            </div>
            <div v-else class="item-no-contenter">
              <div v-if="item.productDescKv.upperRightTag && item.yearCardEndTime" class="time">
                {{
                  `${item.productDescKv.upperRightTag}${
                    Math.floor(time / 60 / 60) < 10
                      ? "0" + Math.floor(time / 60 / 60)
                      : Math.floor(time / 60 / 60)
                  }:${
                    Math.floor(time / 60) % 60 < 10
                      ? "0" + (Math.floor(time / 60) % 60)
                      : Math.floor(time / 60) % 60
                  }:${time % 60 < 10 ? "0" + (time % 60) : time % 60}`
                }}
              </div>
              <div v-else-if="item.productDescKv.upperRightTag" class="tip-bg">{{ item.productDescKv.upperRightTag }}</div>
              <div class="text-doc">{{ item.title }}</div>
              <div>
                <span class="price-icon">￥</span><span class="price">{{ getPrice(item.discountPrice) }}</span>
              </div>
              <div v-if="item.awardId > 0 || +item.showOriginPrice === 1" class="second">
                ￥{{ getPrice(item.originPrice) }}
              </div>
              <div class="item-strikethroughPrice" v-if="item.productDescKv.strikethroughPrice">{{ item.productDescKv.strikethroughPrice }}</div>
              <div class="item-nom">{{ item.productDescKv.bottomTag }}</div>
            </div>
          </div>
        </div>
        <div v-if="realPackageList[selectMenu].productDescKv&&realPackageList[selectMenu].productDescKv.intro"
          :class="realPackageList[selectMenu].isPureSign == 1 ? 'tip-doc' : 'tipNoAfter'" @click="handleClickTip()">
          {{
            realPackageList[selectMenu].productDescKv.intro
          }}
        </div>
        <div class="all-equity-container">
          <div class="all-equity-tab-items">
            <div class="all-equity-tab-item" :class="{ active: equitDetailIndex == 1 }" @click="handleEquitDetail(1)">
              <p>APP权益</p>
              <span></span>
              <img class="all-equity-tab-tip"
                src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758188052516_74148.png" alt="">
            </div>
            <div class="all-equity-tab-item" :class="{ active: equitDetailIndex == 2 }" @click="handleEquitDetail(2)">
              <p>小程序权益</p>
              <span></span>
              <img class="all-equity-tab-tip"
                src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758188052516_74148.png" alt="">
            </div>
          </div>
          <div class="all-equity-icon-items">
            <div :key="i" v-for="(item, i) in equitDetailIndex == 1 ? appEquityData : miniProgramEquityData"
              class="all-equity-icon-item" @click="handleSwipeChange(i)" :id="'select' + i">
              <img class="icon" :src="i == swipeIndex ? item.activeIcon : item.icon" />
              <div class="title" :style="{ color: i == swipeIndex ? '#7A3104' : '#8597A6' }">{{ item.name }}</div>
              <div class="divider" :class="[i != swipeIndex && 'hide']"></div>
            </div>
          </div>
          <div class="swiper-container all-equity-list">
            <div class="swiper-wrapper">
              <div class="swiper-slide"
                v-for="(item, index) in equitDetailIndex == 1 ? appEquityData : miniProgramEquityData" :key="index">
                <div class="all-equity-wrapper">
                  <div class="swiper-title-wrap">
                    <div class="swiper-title">
                      {{ item.title }}
                      <div class="swiper-line"></div>
                    </div>
                  </div>
                  <div class="swiper-subtitle">{{ item.subtitle }}</div>
                  <div class="swiper-cnt">
                    <div class="swiper-equity">
                      <img class="swiper-icon"
                        src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758180834122_51750.png" />
                      <div class="swiper-text">权益说明</div>
                    </div>
                    <div class="swiper-desc">{{ item.desc }}</div>
                    <img class="swiper-img" :src="item.img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="other">
        <div class="o-item" @click="goQuestion">
          <div class="o-text">常见问题</div>
          <div class="line"></div>
        </div>
        <div class="o-item" v-if="sourceC == 'ios' && versionStr >= '5002'" @click="restoreProduct">
          <div class="o-text">恢复购买</div>
          <div class="line"></div>
        </div>
        <div class="o-item" @click="goPrivacy">
          <div class="o-text">隐私政策</div>
          <div class="line"></div>
        </div>
        <div class="o-bottom">
          <div class="text-bottom">联系客服</div>
          <div class="b-tip">客服电话：<span>4000 100 180</span></div>
          <div class="b-tip">工作时间：周一至周日 08:00-22:00</div>
        </div>
      </div>
      <div class="footer-zhan"></div>
    </div>
    <Footer class="footer-container" :Info="Info" :source="sourceC" :item="realPackageList[selectMenu]" title="开通年度会员"
      checkedColor="#D57141" btnText="Info.memberProductList[selectMenu].title" ref="footer" :currentProduct="currentProduct"
      @toggleMemberProductPopup="toggleMemberProductPopup" />
    <van-popup v-model="showPop" round>
      <div class="pop-content">
        <div class="pop-title">自动续费声明</div>
        <div class="pop-scroll">
          <template v-if="sourceC == 'ios'">
            <p>
              1.付款：“连续包月/季/年”会员为自动续费类商品，确认购买后，会从您的苹果iTunes账号中扣款
            </p>
            <p>
              2.续费：在您订阅周期到期前24小时内，苹果会自动从iTunes账户中扣款，扣款成功将自动延长会员有效期
            </p>
            <p>
              3.取消付费：如需取消续费，请在距离订阅期至少24小时之前，手动在Apple ID账户设置中关闭自动续费，关闭后不再扣款
            </p>
          </template>
          <template v-else>
            <p>
              1.付款：“连续包月/季/年”会员为自动续费类商品，确认购买后，会从您的支付账号中扣款
            </p>
            <p>
              2.续费：在您订阅周期到期前1天，支付平台会自动从支付账户中扣款，扣款成功将自动延长会员有效期
            </p>
            <p>
              3.取消付费：如需取消续费，请在距离订阅期至少24小时之前，手动在支付平台账户设置中关闭自动续费，关闭后不再扣款
            </p>
          </template>
        </div>
        <div class="pop-footer">
          <div class="know" @click="showPop = false">知道了</div>
        </div>
      </div>
    </van-popup>
    <div class="suc-van-popup-container">
      <van-popup v-model="showSuc" :get-container="() => { return document.querySelector('suc-van-popup-container'); }"
        round closeable :close-icon="imgX">
        <div class="pop-suc">
          <img :src="icon_member_bg" class="pop-img" />
          <div class="pop-begin" @click="beginStudy()">赠送给好友会员3天体验卡</div>
        </div>
      </van-popup>
    </div>
    <same-member-product-popup v-if="showSameProductPopup" @toggleMemberProductPopup="toggleMemberProductPopup">
    </same-member-product-popup>
    <div class="share-wrap" v-if="showShare" @click="handleClose" style="width:100%;position:fixed;bottom:0;left:0">
      <invite-share :shareUrl="Info.shareUrl" :shareTitle="Info.shareTitle" :shareDesc="Info.shareDesc"
        @closeWrap="closeShare" actionCode="hzxx3117"></invite-share>
    </div>
    <!-- 2023年秋季开学季活动-会员购买完成后出现弹框 -->
    <van-popup v-model="showAct20230901Dialog" class="act20230901-dialog">
      <div class="title">
        赠送给您
      </div>
      <div class="bd">
        <img :src="popupImgUrl" alt="代金券" class="coin">
        <p class="text">
          {{ popupText }}
        </p>
      </div>
      <div class="ft">
        <div class="button" @click="handleJumpToShop">
          前往小盒商城领取奖品
        </div>
      </div>
      <div class="close" @click="handleCloseAct20230901Dialog"></div>
    </van-popup>
    <!-- APP+小程序 双重权益重磅来袭！ -->
    <van-popup v-model="showEquityPopup" class="equity-popup-container" round position="center" style="width: 90%;"
      :closeable="false">
      <div class="equity-popup-wrap">
        <img class="equity-popup-img"
          src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758264105528_52961.png" />
        <div class="equity-popup-btn" @click="handleToMiniProgram">去小程序使用</div>
        <img class="equity-popup-close" src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758248640803_48002.png"
          @click="handleEquitPop(0)" />
      </div>
    </van-popup>

    <van-popup v-model="showYearCardPromotionInfoPopup" class="year-popup-container" round position="center" style="width: 100%;"
      :closeable="false">
      <div class="year-popup-wrap">
        <img class="year-popup-bg"
          src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1765866534462_34443.png" />
        <img class="year-popup-img"
          src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1765866534461_24713.png" />
        <div class="year-popup-btn" @click="handleYearPop(0)">立即领取特惠</div>
        <img class="year-popup-close" src="https://aistudyqiniu.knowbox.cn/fe/resources/img_1758248640803_48002.png"
          @click="handleYearPop(0)" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem)
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import Bar from "./member_bar";
import Footer from "./member_footer_ai_study";
import SameMemberProductPopup from "./same_member_product_popup";
import { restoreProduct } from "@/utils/hybird";
import inviteShare from "../parent_active/invite-parent/common/invite-share";//邀请
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
const fromHarmonyOS = utils.getQueryString("fromHarmonyOS");
const categoryId = utils.getQueryString("categoryId");
const pageChannelId = utils.getQueryString("pageChannelId");
const productId = utils.getQueryString("productId"); //商品Id
const strAwardId = utils.getQueryString("awardId");

var vm = null;
window.failToast = function (res) {
  if (res != "cancel") {
    if (vm.sourceC === 'ios') {
      if (vm.Info.act20230901) {
        utils.sendLog({
          token,
          version,
          source,
          extensionJson: {
            product: vm.selectMenu
          }
        }, 'hzxx4211');

        vm.showAct20230901Dialog = true;
      }
      vm && vm.getInfo();
    }
  }
};

window.jsCallback = function (res) {
  if (res != "cancel") {
    // for android only
    if (vm.Info.act20230901) {
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {
          product: vm.selectMenu
        }
      }, 'hzxx4211');

      vm.showAct20230901Dialog = true;
    }

    if (window.goAddress)
      window.location.href =
        "/#/address?version=" +
        version +
        "&token=" +
        token +
        "&source=" +
        source;
    else {
      vm && vm.getInfo();
    }
  }
};

let _id = null;

export default {
  components: {
    Bar,
    Footer,
    SameMemberProductPopup,
    inviteShare
  },
  data() {
    return {
      time: 0,
      priceDown: 0,
      priceDownId: null,
      nowVersion: version,
      icon_member_bg: require("../../assets/images/member_new/ic_member_month.png"),
      icon_month: require("../../assets/images/member_new/ic_member_month.png"),
      icon_season: require("../../assets/images/member_new/ic_member_season.png"),
      icon_year: require("../../assets/images/member_new/ic_member_year.png"),
      versionStr: '',
      imgX: require("../../assets/images/member_new/btn_X.png"),
      showTitleBg: false,
      showPop: false,
      showShare: false,
      showSuc: false,
      selectMenu: 0,
      showSameProductPopup: false, // 已购买套餐弹窗
      sourceC: "", //平台
      text: {},
      Info: {
        banner: {
        },
        memberInfo: {
          isMember: 0, // 是否是会员 1是 0否
          username: "小白兔白又白🐰",
          memberDesc: "开通会员 全场免费学", // 会员信息描述
        },
        needUpgrade: 1, // 是否升级,1是 0否,如果是1时
        superMember: 12, // 超级会员时间,单位天
        syncTest: 124, // 同步练会员时间,单位天
        awardList: [
          //助学金记录列表
          {
            recordId: 1, // 助学金记录id
            awardId: 7, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 2, // 助学金记录id
            awardId: 7, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 3, // 助学金记录id
            awardId: 8, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 4, // 助学金记录id
            awardId: 8, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 5, // 助学金记录id
            awardId: 9, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 6, // 助学金记录id
            awardId: 9, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
        ],
        memberProductList: [
          // needUpgrade=1时此字段只有升级对应产品
          {
            productId: 993, // 产品id
            title: "连续包月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 1, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 23, // 会员连续包月
            awardId: -9, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 994, // 产品id
            title: "连续包月优惠", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 1, // 是否有价格比对
            productType: 24, // 会员连续包月优惠
            awardId: -9, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 995, // 产品id
            title: "连续包季", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 25, // 会员连续包季
            awardId: -8, //助学金id
            productDesc: ["11", "11", "11"],

          },
          {
            productId: 996, // 产品id
            title: "连续包年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 26, // 会员连续包年
            awardId: -7, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 997, // 产品id
            title: "1个月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 27, // 会员1个月
            awardId: 0, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 998, // 产品id
            title: "1个季度", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 28, // 会员1个季度
            awardId: 0, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 0, // 产品id
            title: "1年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 29, // 会员1年
            awardId: 0, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 993, // 产品id
            title: "连续包月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 1, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 23, // 会员连续包月
            awardId: 9, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 9955, // 产品id
            title: "连续包季", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 25, // 会员连续包季
            awardId: 8, //助学金id
            productDesc: ["11", "11", "11"],
          },
          {
            productId: 996, // 产品id
            title: "连续包年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 26, // 会员连续包年
            awardId: 7, //助学金id
            productDesc: ["11", "11", "11"],
          },
        ],

        act20230901: 0, // 活动是否开启 1是 0否
      },
      realPackageList: [
        // needUpgrade=1时此字段只有升级对应产品
        {
          productId: 993, // 产品id
          title: "连续包月", // 标题
          originPrice: 35, // 原价
          discountPrice: 1, // 优惠价
          isPromotion: 1, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 0, // 是否有价格比对
          productType: 23, // 会员连续包月
          awardId: -7, //助学金id
          productDesc: ['', '', ''],

        },
        {
          productId: 994, // 产品id
          title: "连续包月优惠", // 标题
          originPrice: 35, // 原价
          discountPrice: 35, // 优惠价
          isPromotion: 0, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 1, // 是否有价格比对
          productType: 24, // 会员连续包月优惠
          awardId: -7, //助学金id
          productDesc: ['', '', ''],

        },
        {
          productId: 995, // 产品id
          title: "连续包季", // 标题
          originPrice: 78, // 原价
          discountPrice: 78, // 优惠价
          isPromotion: 0, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 0, // 是否有价格比对
          productType: 25, // 会员连续包季
          awardId: -7, //助学金id
          productDesc: ['', '', ''],
        },
      ],

      appEquityData: [
        {
          name: "同步校内",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_88098.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_49928.png",
          title: "精准对标",
          subtitle: "全年级练习免费使用，引入新课标必读",
          desc: "数学同步练，巩固课内知识，提升数学思维；语文同步练，每天10分钟，提升语文积累；英语同步练，有效又有趣的课内英语练习",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_45673.png",
        },
        {
          name: "AI伴学",
          icon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_40485.png",
          activeIcon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_45648.png",
          title: "AI伴学",
          subtitle: "打造学习闭环，及时检验成果",
          desc: "小程序AI伴学，校内同步训练+智能查漏补缺+专项进阶提升，打造学习闭环，助力成绩进步",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_78371.png",
        },
        {
          name: "爆款IP",
          icon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_12442.png",
          activeIcon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_71536.png",
          title: "爆款IP",
          subtitle: "与爆款IP同行，趣味学习知识",
          desc: "曲小奇、小马菲菲、兽王、我不是白吃、好奇动物、四大名著等爆款IP热门学习素材，成长路上的好伙伴",
          img: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_47230.png",
        },
        {
          name: "通识教育",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_29531.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_77482.png",
          title: "通识教育",
          subtitle: "通识教育，助力全面发展",
          desc: "人文、科学、英语启蒙等100多个主题的通识教育学习内容，辅助学生全面发展",
          img: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_90517.png",
        },
        {
          name: "特权工具",
          icon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_89575.png",
          activeIcon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_76977.png",
          title: "特权工具",
          subtitle: "特权工具，畅游学习关卡",
          desc: "速算闯关，全网打擂，夯实数学基础；魔法学院，核心训练数学5大模块；成语学堂，6大板块，600个成语关卡",
          img: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_21712.png",
        },
        {
          name: "专享权益",
          icon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_54505.png",
          activeIcon: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_56248.png",
          title: "专享权益",
          subtitle: "会员标识，翻倍学贝",
          desc: "会员标识，彰显身份；签到获得翻倍学贝",
          img: "https://aistudyqiniu.knowbox.cn/fe/resources/img_1758695271459_28507.png",
        }
      ],
      miniProgramEquityData: [
        {
          name: "精准同步",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_88098.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_49928.png",
          title: "精准对标",
          subtitle: "教材同步练，夯实每堂课；紧跟校内进度，一课一练不留死角",
          desc: "完全匹配教材章节，每日课后同步训练，即时巩固知识点，基础扎实才能轻松应对考试。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_45673.png",
        },
        {
          name: "智能错题",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_94269.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_77719.png",
          title: "举一反三",
          subtitle: "错题智能变形，突破思维定式；错题秒变新题，彻底攻克薄弱点",
          desc: "基于错题数据，AI自动生成同类变形题，举一反三强化训练，错题变秘籍，1题抵10题，让孩子真正理解而非死记硬背。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_78371.png",
        },
        {
          name: "AI深度练习",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894574_565.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_5791.png",
          title: "科学记忆",
          subtitle: "按遗忘曲线规划，错题不忘；错题定时推送，记忆效率翻倍",
          desc: "根据艾宾浩斯遗忘曲线，在最佳时机推送历史错题练习，科学补漏让记忆牢固不遗忘。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_48534.png",
        },
        {
          name: "培优进阶",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_29531.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_77482.png",
          title: "进阶突破",
          subtitle: "高分学员专属能力提升，90分以上自动开启拔高模式",
          desc: "针对学有余力的学生，自动推送高难度拓展题，挑战思维极限，稳居高分梯队。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_50432.png",
        },
        {
          name: "真人辅导",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_75404.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_62365.png",
          title: "AI+真人辅教",
          subtitle: "AI诊断+老师解读，当日补漏；薄弱点视频讲解当日达",
          desc: "AI分析答题弱项，辅导老师当日录制讲解视频并微信发送，知识点当日清不留隐患。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311893_86696.png",
        },
        {
          name: "复习检测",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_72706.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_94671.png",
          title: "及时复习",
          subtitle:
            "每周，每单元、期中期末，定期学情复盘，拒绝盲目累积；综合检验，漏洞不留存。",
          desc: "基于当周，当前阶段以及期中期末阶段的学习数据，生成专属复习题组，集中检验巩固，确保知识闭环掌握。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311894_30783.png",
        },
        {
          name: "学情报告",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_18479.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_62851.png",
          title: "清晰全面",
          subtitle: "日周阶段三重报告，学习效果看得见，家长随时掌握进步轨迹",
          desc: "每日学习报告即时反馈，周报告深度分析趋势，阶段报告全面了解学生学情变化。辅导老师解读指导，学习效果全程可视化。学习规划更明确。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311893_70635.png",
        },
        {
          name: "每日一练",
          icon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_22977.png",
          activeIcon: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756294894575_17627.png",
          title: "思维趣味游戏",
          subtitle: "碎片时间玩出逻辑力，每日几分钟趣味游戏题，练思维不枯燥",
          desc: "每日推送轻量益智游戏，巧妙融入数学逻辑训练，潜移默化提升解题思维活跃度。",
          img: "https://susuanqiniu.knowbox.cn/fe/study-plan/img_1756296311896_60305.png",
        },
      ],
      swipeIndex: 0,
      swiperInstance: null, // 新增：保存swiper实例
      isIconClicking: false, // 标记是否正在通过点击图标切换
      clickTimer: null, // 点击定时器
      showEquityPopup: false,
      showYearCardPromotionInfoPopup: false,
      equitDetailIndex: 1,
      showAct20230901Dialog: false,
      loading: true
    };
  },
  created() {
    this.getInfo();
    vm = this;
    this.versionStr = utils.getQueryString('version').split('.').join('');
  },
  mounted() {
    this.sourceC = source.match("iPhone") ? "ios" : "and";
    const self = this;
    this.swiperInstance = new Swiper(".swiper-container", {
      loop: false,
      slidesPerView: "auto",
      autoplay: false,
      spaceBetween: 10,
      resistanceRatio: 0, // 禁用边界阻力，防止过度滚动
      centeredSlides: false, // 确保slides不居中
      onSlideChange: function (swiper) {
        // 如果是点击图标触发的切换，不处理
        if (self.isIconClicking) return;
        
        // 滑动过程中实时更新
        self.updateSwipeIndex(swiper.activeIndex);
      },
      onSlideChangeEnd: function (swiper) {
        // 如果是点击图标触发的切换，不处理
        if (self.isIconClicking) return;
        
        // 滑动结束时确保更新
        self.updateSwipeIndex(swiper.activeIndex);
      }
    });
  },
  methods: {
    // 统一处理swipeIndex更新
    updateSwipeIndex(newIndex) {
      const maxIndex = this.equitDetailIndex == 1 ? this.appEquityData.length - 1 : this.miniProgramEquityData.length - 1;
      
      // 确保索引在有效范围内
      const validIndex = Math.min(Math.max(0, newIndex), maxIndex);
      
      if (this.swipeIndex !== validIndex) {
        this.swipeIndex = validIndex;
        this.scrollIconIntoView(validIndex);
      }
    },
    closeShare() {
      this.showShare = false;
    },
    typePriceMap(productType) {
      let discountPrice;
      this.Info.memberProductList.some((item, index) => {
        if (item.productType === productType) {
          discountPrice =
            productType === 24 ||
              productType === 52 ||
              productType === 53 ||
              productType === 54 ||
              productType === 55 ||
              productType === 56
              ? item.originPrice
              : item.discountPrice;
          return true;
        }
      });
      return discountPrice;
    },
    formData() {
      this.Info.memberProductList.forEach((item, index) => {
        switch (item.productType) {
          case 57:
            //85折1个月
            this.text[item.productId] = `选择【连续包月】套餐，每月立省${item.originPrice -
              (this.typePriceMap(54) || this.typePriceMap(71))
              }元`;
            break;
          case 58:
            this.text[item.productId] = `选择【连续包季】套餐，每季立省${item.originPrice - this.typePriceMap(55)
              }元`;
            break;
          case 59:
            this.text[item.productId] = `选择【连续包年】套餐，每年立省${item.originPrice - this.typePriceMap(56)
              }元`;
            break;
          case 71:
            this.text[
              item.productId
            ] = `免费期结束后，每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 54:
            this.text[
              item.productId
            ] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 55:
            this.text[
              item.productId
            ] = `次季起每季自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 56:
            this.text[
              item.productId
            ] = `次年起每年自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 23:
            this.text[
              item.productId
            ] = `每月自动续费${item.discountPrice}元，可随时关闭`;
            break;
          case 24:
          case 52:
          case 53:
            if (item.productType == 24) {
              this.btnDiscountPrice = item.discountPrice;
            }
            this.text[
              item.productId
            ] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 25:
            this.text[
              item.productId
            ] = `每季自动续费${item.discountPrice}元，可随时关闭`;
            break;
          case 26:
            // this.text[item.productId] = `每年自动续费${item.discountPrice}元，可随时关闭`;
            this.text[item.productId] =
              "次年起每年自动续费308.00元，可随时关闭";
            break;
          case 27:
            let typeMap =
              this.typePriceMap(71) ||
              this.typePriceMap(23) ||
              this.typePriceMap(24) ||
              this.typePriceMap(52) ||
              this.typePriceMap(53);
            this.text[item.productId] = `选择【连续包月】套餐，每月立省${item.discountPrice - typeMap
              }元`;
            break;
          case 28:
            this.text[item.productId] = `选择【连续包季】套餐，每季立省${item.discountPrice - this.typePriceMap(25)
              }元`;
            break;
          case 29:
            this.text[item.productId] = `选择【连续包年】套餐，每年立省${item.discountPrice - this.typePriceMap(26)
              }元`;
            break;
        }
      });
    },
    async getInfo() {
      const [resp] = await ajax.all([
        ajax.get("/pay/common/member-sale-page-new", {
          params: {
            token,
            version,
            source,
            fromHarmonyOS
          },
        }),
      ]);
      if (resp.data.code == 99999) {
        let data = resp.data.data;
        this.Info = data;
        this.selectMenu = this.Info.indexSelected;
        this.currentProduct = this.Info.memberProductList[this.selectMenu];
        this.setMemberDialogBg();
        this.showIf = true;
        if (this.Info.needUpgrade) {
          gio("track", "vipUpdatePage_show", this.getGioParams());
          utils.sendLog(
            {
              token,
              version,
              source,
              extensionJson: this.getGioParams(),
            },
            "hzxx912"
          );
        } else {
          gio("track", "vipOpenPgae_show", this.getGioParams());
          utils.sendLog(
            {
              token,
              version,
              source,
              extensionJson: this.getGioParams(),
            },
            "hzxx910"
          );
        }

        this.formData();
        this.setDiscountPackageInfo(strAwardId);

        const val = data.memberProductList.filter((v) => v.yearCardEndTime);
        if (val.length) {
          this.time = val[0].yearCardEndTime;
          _id && clearInterval(_id);
          _id = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              clearInterval(_id);
            }
          }, 1000);
        }

        const val1 = data.memberProductList.filter(
          (v) => v.productDescKv.compareProduct.isShow
        );
        if (val1.length) {
          this.priceDown = val1[0].productDescKv.compareProduct.price;
          this.priceDownId && clearInterval(this.priceDownId);
          this.priceDownId = setInterval(() => {
            this.priceDown -= 4;
            if (this.priceDown <= val1[0].discountPrice) {
              this.priceDown = val1[0].discountPrice;
              clearInterval(this.priceDownId);
            }
          }, 1);
        }

        if (data.yearCardPromotionInfo.isShowPopWindow) {
          this.handleYearPop(1);
        }
      }
      this.loading = false;

    },
    beginStudy() {
      this.showSuc = false;
      //调起分享
      this.showShare = true;
      // window.location.href = 'hybird://method/exit'
      utils.sendLog({
        token: token,
        version: version,
        source: source,
        extensionJson: {
          type: 1,
        }
      }, 'hzxx3114')
    },
    handleClose(e) {
      if (e.target.classList.contains('share-wrap')) {
        this.showShare = false;
      }
    },
    jumpBanner(jumpUrl) {
      if (jumpUrl.length == 0) return;
      let url = encodeURIComponent(jumpUrl);
      window.location.href = "hybird://method/openNewWindow?url=" + url;
    },
    setDiscountPackageInfo(awardId) {
      //radio=-1表示取消
      this.realPackageList = this.Info.memberProductList.filter(
        (n) => n.awardId <= 0
      );
      let locationIndex = 0;
      this.realPackageList.forEach((item, i) => {
        //有可用优惠卷
        if (this.Info.awardList.find(n => n.awardId == -item.awardId) != null) {
          let wardId = -item.awardId;
          let discountPackage = this.Info.memberProductList.filter((n) => n.awardId == wardId)[0];
          let replaceIndex = this.realPackageList.findIndex((n) => n.awardId == -wardId);
          if (wardId == awardId) {
            locationIndex = replaceIndex;
          }
          this.realPackageList.splice(replaceIndex, 1, discountPackage);
        }
      })

      if (awardId != null && awardId > 0) {
        this.selectMenu = locationIndex;

      }
      this.$refs.footer.setButtonName(this.realPackageList[this.selectMenu]);
    },
    selectPackage(idx, currentItem) {
      this.currentProduct = currentItem;
      this.selectMenu = idx;
      this.$refs.footer.setButtonName(currentItem);

      this.setMemberDialogBg();
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {
          produtcid: currentItem.productId
        }
      }, 'hzxx35057');
    },
    setMemberDialogBg() {
      if (vm.realPackageList.length && vm.realPackageList.length - 1 >= this.selectMenu) {
        switch (vm.realPackageList[this.selectMenu].identityDesc) {
          case "月度会员":
            vm.icon_member_bg = vm.icon_month;
            break;
          case "季度会员":
            vm.icon_member_bg = vm.icon_season;
            break;
          case "年度会员":
            vm.icon_member_bg = vm.icon_year;
            break;
        }
      }
    },
    getPrice(price) {
      if (!price) return false;
      // let arr = price.toString().split(".");
      return price.toString();
    },
    handleClickTip() {
      if (this.realPackageList[this.selectMenu].isPureSign == 1) {
        this.showPop = true;
        utils.sendLog({
          token,
          version,
          source,
          extensionJson: {}
        }, 'hzxx35058');
      }
    },
    getGioParams() {
      return {
        categoryId,
        pageChannelId,
        isVip: this.Info.isMember,
        productId: productId || this.currentProduct.productId
      };
    },
    renewDoc() {
      //打开续费说明
    },
    showEquities(index) {
      let urlO = window.location.href.replace(
        /member_ai_study/,
        "member_equity_new"
      );
      console.log(urlO + "&active=" + index + "&entry=0");
      let url = encodeURIComponent(urlO + "&active=" + index + "&entry=0");

      window.location.href =
        "hybird://method/openNewWindow?url=" + url;
      //  this.$router.push("/member/member_equity_new?active=" + index + "&title=VIP会员尊享内容特权");
    },
    goQuestion() {
      let url = window.location.href.split("?")[0];
      let path =
        this.source === "ios"
          ? url.split("member_ai_study").join("common_problems")
          : url.split("member_ai_study").join("common_problems?hideTitleBar=false");
      console.log(path);
      url = encodeURIComponent(path);
      window.location.href = "hybird://method/openNewWindow?url=" + url;
    },
    goPrivacy() {
      let url = encodeURIComponent(this.source === "ios"
        ? "https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy-iOS.html?hideTitleBar=false"
        : "https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy.html?hideTitleBar=false"
      );

      window.location.href =
        "hybird://method/openNewWindow?url=" +
        url +
        "&title=小盒课堂用户隐私协议";
    },
    toggleMemberProductPopup() {
      this.showSameProductPopup = !this.showSameProductPopup;
    },
    restoreProduct() {
      restoreProduct();
    },
    jump(item) {
      if (item.jumpUrl) {
        utils.sendLog({
          token: token,
          version: version,
          source: source,
          extensionJson: {
            actBannerId: item.id,
          }
        }, 'hzxx3246');
        let url = encodeURIComponent(item.jumpUrl);
        window.location.href = "hybird://method/openNewWindow?url=" + url;
      }
    },
    // 跳转到小盒商城
    handleJumpToShop() {
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {
          product: this.selectMenu
        }
      }, 'hzxx4212');

      setTimeout(() => {
        // let from = 'app,iosparents,10';
        let from = 'app,iosparents,17';

        if (this.sourceC === 'and') {
          // from = 'app,androidparents,10';
          from = 'app,androidparents,17';
        }

        window.location.href = `hybird://method/openCustomParamsWXMiniProgram?userName=gh_6a5ef4d7fbbe&miniProgramType=0&isShowConfirmDialog=0&path=${encodeURIComponent('/pages/entry/index?from=' + from)}`;
      }, 200);
    },

    handleCloseAct20230901Dialog() {
      this.showAct20230901Dialog = false;
    },
    handleSwipeChange(index) {
      // 清除之前的定时器，防止多个定时器重叠
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      
      // 标记正在通过点击图标切换，防止事件回调干扰
      this.isIconClicking = true;
      this.swipeIndex = index;
      
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(index);
      }
      
      // 设置新的定时器，确保状态重置
      this.clickTimer = setTimeout(() => {
        this.isIconClicking = false;
        this.clickTimer = null;
      }, 300); // 减少延迟时间，提高响应性
    },
    // 滚动对应图标到可视区域
    scrollIconIntoView(index) {
      this.$nextTick(() => {
        const iconContainer = document.querySelector('.all-equity-icon-items');
        const targetIcon = document.querySelector(`#select${index}`);
        
        if (iconContainer && targetIcon) {
          const containerRect = iconContainer.getBoundingClientRect();
          const iconRect = targetIcon.getBoundingClientRect();
          const margin = 0.16 * 50; // 0.16rem转px
          
          // 计算需要滚动的距离
          let scrollLeft = iconContainer.scrollLeft;
          
          // 如果图标在容器左边界外
          if (iconRect.left < containerRect.left) {
            scrollLeft = scrollLeft + iconRect.left - containerRect.left - margin;
          }
          // 如果图标在容器右边界外
          else if (iconRect.right > containerRect.right) {
            scrollLeft = scrollLeft + iconRect.right - containerRect.right + margin;
          }
          
          // 平滑滚动
          iconContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      });
    },
    handleEquitPop(flag) {
      this.showEquityPopup = !!flag;
      if(flag) {
        utils.sendLog({
          token,
          version,
          source,
          extensionJson: {}
        }, 'hzxx35054');
      }
    },
    handleYearPop(flag) {
      this.showYearCardPromotionInfoPopup = !!flag;
    },
    handleToMiniProgram() {
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {}
      }, 'hzxx35056');
      this.handleEquitPop(false);
      window.location.href = "hybird://method/openCustomParamsWXMiniProgram?userName=gh_6fc3c5fb5468&miniProgramType=0&isShowConfirmDialog=1&path=%2Fpages%2Fentry%2Findex%3Fscene%3DR";
    },
    handleEquitDetail(index) {
      this.equitDetailIndex = index;
      this.swipeIndex = 0;
      
      // 将图标容器滚动回第一个位置
      this.$nextTick(() => {
        const iconContainer = document.querySelector('.all-equity-icon-items');
        if (iconContainer) {
          iconContainer.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
      });
      
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(0);
        // 等待DOM更新后重新初始化Swiper
        this.$nextTick(() => {
          this.swiperInstance.update();
        });
      }
    }
  },
  computed: {
    //支付成功后弹窗中图片的url
    popupImgUrl() {
      switch (this.selectMenu) {
        case 0:
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-30.png";
        case 1:
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-68.png";
        case 2:
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-248.png";
        default:
          return "";
      }
    },
    //支付成功后弹窗中图片的文字
    popupText() {
      switch (this.selectMenu) {
        case 0:
          return "30元代金券";
        case 1:
          return "68元代金券";
        case 2:
          return "248元代金券+爱立熊便携家用打印机";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
// 100vw = 375px, px : rem = 50 : 1 
.mermber {
  overflow: hidden;
  text-align: center;
  font-family: PingFangSC-Medium;
  line-height: 1;
  min-height: 13.34rem;

  /deep/ .member-bar-wrap {
    width: 100%;
    height: calc(.88rem + constant(safe-area-inset-top));
    height: calc(.88rem + env(safe-area-inset-top));
  }

  .main {
    position: absolute;
    width: 100%;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    background: #ffffff;

    .title_img {
      width: 100%;
      height: 5.6rem;
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
    }

    .content {
      position: relative;
      z-index: 1;
      padding: 0 0 0.56rem;
      text-align: left;
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      margin-top: 0.8rem;
      &.short {
        margin-top: 0.4rem;
      }

      .content-user-wrap {
        display: flex;
        align-items: center;
        margin: 0.28rem 0.32rem 0.4rem;

        .content-user-img {
          width: 0.96rem;
          height: 0.96rem;
          border-radius: 50%;
          margin-right: 0.12rem;
        }

        .content-user-text {
          .content-user-name {
            font-weight: 600;
            font-size: 0.36rem;
            color: #000000;
          }

          .content-user-date {
            font-weight: 400;
            font-size: 0.24rem;
            color: rgba(0, 0, 0, 0.4);
            line-height: 0.32rem;
            margin-top: 0.12rem;
          }
        }
      }

      .rights {
        display: flex;
        align-items: center;
        margin-top: 0.64rem;

        .vip-rights {
          flex: 1;

          .title-block {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 1.16rem;
            background: linear-gradient(180deg, #FFDAB0 0%, #FFBD7E 100%);
            border-radius: 0.3rem 0.3rem 0px 0px;

            .icon {
              width: 0.56rem;
              height: 0.56rem;
              margin-right: 0.04rem;
            }

            .text {
              font-size: 0.32rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #7A3104;
              line-height: 0.56rem;
              padding: 0.02rem 0.16rem 0 0;
            }
          }

          .rights-block {
            background: #FFF3E9;
            border-radius: 0px 0px 0.3rem 0.3rem;
            border: 0.01rem solid #FFA509;
            width: 100%;
            padding: 0 0.3rem;
            box-sizing: border-box;
            height: 8rem;
            box-sizing: border-box;

            .rights-cell {
              padding-top: 0.42rem;
              display: flex;
              align-items: flex-start;
              flex-direction: column;

              .benefit-type {
                display: flex;
                align-items: center;
                justify-content: center;

                .vip-icon {
                  width: 0.48rem;
                  height: 0.3rem;
                }

                .title {
                  font-size: 0.24rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #7A3104;
                  padding-left: 0.12rem;
                }
              }

              .list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.26rem 0.07rem 0;
                width: 100%;
                box-sizing: border-box;

                .list-cell {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  width: 1rem;

                  .list-icon {
                    width: 0.56rem;
                    height: 0.56rem;
                  }

                  .list-text {
                    font-size: 0.18rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3A4961;
                    padding-top: 0.08rem;
                  }
                }
              }
            }
          }
        }

        .not-vip-rights {
          width: 2.36rem;

          .title-block {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 0.98rem;
            background: linear-gradient(180deg, #F1F5F9 0%, #EBF1F5 100%);
            border-radius: 0px 0.3rem 0px 0px;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3A4961;
          }

          .cnt {
            height: 7.82rem;
            width: 100%;
            box-sizing: border-box;
            background: #F9FBFC;
            border-radius: 0px 0px 0.3rem 0px;
            border: 0.01rem solid #D7E5F7;
            border-left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0.26rem 0.24rem 0;

            .cnt-cell {
              width: 1.94rem;
              padding: 0.6rem 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.22rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3A4961;
              line-height: 0.34rem;
              flex-direction: column;
            }

            .cnt-cell+.cnt-cell {
              border-top: solid 0.01rem #CCDBE8;
            }
          }
        }
      }

      .vip-img {
        width: 0.88rem;
        height: 0.48rem;
      }

      .content-equity-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 0.56rem;
        background: #FFECCD;
        border-radius: 0.16rem;
        padding: 0 0.16rem;
        margin: 0 0.32rem;

        .content-equity-l {
          display: flex;
          align-items: center;

          .content-equity-img {
            width: 0.42rem;
            height: 0.32rem;
            margin-right: 0.16rem;
          }

          .content-equity-text {
            font-weight: 400;
            font-size: 0.2rem;
            color: #CD5C04;
          }
        }

        .content-equity-r {
          width: 0.32rem;
          height: 16px;
        }
      }

      .menu {
        padding: 0.24rem 0.32rem;
        display: -webkit-box;
        overflow-x: auto;

        .text-doc {
          margin-top: 0.64rem;
          margin-bottom: 0.2rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #202b43;
          line-height: 0.42rem;
          font-size: 0.3rem;
          color: #404040;
        }

        .price {
          font-size: 0.6rem;
          font-family: BebasNeue;
          margin-left: -0.08rem;
          font-weight: bold;
          font-size: 0.52rem;
          color: #404040;
          line-height: 0.64rem;
        }

        .price-icon {
          width: 0.22rem;
          height: 0.56rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          margin-left: -0.12rem;
          line-height: 0.56rem;
          margin-top: 0.05rem;
          font-size: 0.3rem;
          color: #404040;
        }

        .price-discount {
          color: #FCB170;
          font-size: 0.24rem;
        }

        .second {
          font-size: 0.24rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #A2B1BF;
          line-height: 0.34rem;
          text-decoration: line-through;
        }

        .item-strikethroughPrice{
          font-weight: 400;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.4);
          line-height: 16px;
          position: absolute;
          width: 2.1rem;
          bottom: 0.5rem;
          text-decoration-line: line-through;
        }

        .item-nom {
          font-weight: 400;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.4);
          line-height: 16px;
          position: absolute;
          width: 2.1rem;
          bottom: 0.2rem;
        }

        .item-no {
          position: relative;
          height: 2.8rem;
          box-shadow: 0 0.08rem 0.16rem 0 rgba(220, 222, 224, 0.3);
          border: 0.02rem solid #FFE9B1;
          border-radius: 0.32rem;
          text-align: center;
          margin-right: 0.16rem;
          background: #FFFCF9;
          overflow: hidden;

          &:last-child {
            margin-right: 0 !important;
          }

          .item-no-contenter{
            width: 100%;
            height: 100%;
            width: 2rem;

          }
          .item-no-contenter-desc8{
            width: 4rem;
            display: flex;
            .bg{
              width: 60%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
            }
          }

          .left{
            position: relative;
            z-index: 1;
            flex: 1;

          }
          .right{
            position: relative;
            z-index: 1;
            flex: 1;
            .text-doc{
              color: rgba(0, 0, 0, 0.4);
            }
            .price-icon{
              color: rgba(0, 0, 0, 0.4);
            }
            .price{
              text-decoration-line: line-through;
              color: rgba(0, 0, 0, 0.4);
            }
          }

          .time{
            width: 100%;
            font-size: 0.24rem;
            color: #FFFFFF;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
            line-height: 0.4rem;
            position: absolute;
            min-width: 1.6rem;
            padding: 0 0.16rem;
            top: 0;
            left: 0;
            background: linear-gradient(270deg, #FF6464 0%, #FF5A14 100%);
            white-space: nowrap;
            height: 0.4rem;
            text-align: center;
          }
          .tip-bg {
            font-size: 0.24rem;
            color: #FFFFFF;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
            line-height: 0.4rem;
            position: absolute;
            min-width: 1.6rem;
            padding: 0 0.16rem;
            top: 0;
            left: 0;
            background: linear-gradient(270deg, #FF6464 0%, #FF5A14 100%);
            border-radius: 0.2rem 0px 0.2rem 0px;
            white-space: nowrap;
            height: 0.4rem;
          }
        }

        .item {
          background: linear-gradient(180deg, #FFDE92 0%, #FFF9C7 100%);
          box-shadow: 0px 2 10px 0px rgba(255, 146, 45, 0.1);
          border: 0.02rem solid #F9C000;

          .text-doc,
          .price-icon,
          .price {
            color: #8D2E00;
          }
        }
      }

      .tip-doc {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a2b1bf;
        line-height: 0.34rem;
        position: relative;
        margin: 0 0.32rem 0.64rem;

        &:after {
          content: "";
          position: absolute;
          top: 0.03rem;
          margin-left: 0.06rem;
          width: 0.24rem;
          height: 0.24rem;
          background: url("https://aistudyqiniu.knowbox.cn/fe/resources/img_1758183443151_99976.png") 0 0 / cover no-repeat;
        }
      }

      .tipNoAfter {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a2b1bf;
        line-height: 0.34rem;
        position: relative;
        margin: 0 0.32rem 0.64rem;
      }

      .all-equity-container {
        .all-equity-tab-items {
          width: 100%;
          height: 0.88rem;
          background: #FFF9E6;
          box-shadow: 0px -10 10px 0px rgba(255, 155, 77, 0.03);
          border-radius: 0.4rem 0.4rem 0px 0px;
          display: flex;
          align-items: center;

          .all-equity-tab-item {
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;

            &.active {
              background: #FFFFFF;
              border-radius: 0.4rem 0.4rem 0px 0px;

              p {
                color: #8D2E00;
              }
            }

            &:first-child {
              .all-equity-tab-tip {
                right: 0;
                transform: scaleX(-1);
              }
            }

            &:last-child {
              .all-equity-tab-tip {
                left: 0;
              }
            }

            p {
              font-weight: 500;
              font-size: 0.32rem;
              color: rgba(205, 92, 4, 0.8);
              line-height: 0.4rem;
              position: relative;
              z-index: 1;
            }

            span {
              display: block;
              width: 1.8rem;
              height: 0.2rem;
              background: #FFF4BF;
              border-radius: 0.08rem;
              margin-top: -0.12rem;
            }

            .all-equity-tab-tip {
              position: absolute;
              width: 0.24rem;
              height: 0.32rem;
              bottom: 0;
            }
          }
        }

        .all-equity-icon-items {
          display: flex;
          align-items: center;
          margin: 0.32rem 0;
          padding: 0 0.24rem;
          overflow-x: auto;

          .all-equity-icon-item {
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 1.44rem;
            margin-left: 0.08rem;
            margin-right: 0.08rem;

            .icon {
              width: 0.84rem;
              height: 0.84rem;
            }

            .title {
              width: 1.44rem;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.24rem;
              color: #8597a6;
              line-height: 0.32rem;
              text-align: center;
              font-style: normal;
              margin-top: 0.08rem;
            }

            .divider {
              width: 0.44rem;
              height: 0.12rem;
              background: linear-gradient(270deg, #ffc03b 0%, #ff7e17 100%);
              border-radius: 0.06rem;
              margin-top: 0.16rem;

              &.hide {
                background: transparent;
              }
            }
          }
        }

        .all-equity-list {
          padding-left: 0.4rem;
          .swiper-slide {
            width: 6.7rem;
            
            &:last-child {
              margin-right: 0.8rem; // 增加右边距，确保最后一个slide有足够的独立空间
            }
          }

          .all-equity-wrapper {
            width: 6.7rem;
            height: 6.96rem;
            background: linear-gradient(180deg, #ffddb6 0%, #fff7e1 100%);
            border-radius: 0.32rem;
            padding: 0.32rem 0.4rem 0.4rem;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;

            .swiper-title-wrap {
              margin-bottom: 0.16rem;
              display: flex;

              .swiper-title {
                font-size: 0.32rem;
                color: #9c3b00;
                position: relative;
                z-index: 1;
                font-weight: bold;

                .swiper-line {
                  height: 0.16rem;
                  background: linear-gradient(90deg, #fdfb53 0%, #fff2a4 100%);
                  border-radius: 0.08rem;
                  width: calc(100% + 0.16rem);
                  position: absolute;
                  left: -0.08rem;
                  bottom: 0;
                  z-index: -1;
                }
              }
            }

            .swiper-subtitle {
              font-size: 0.26rem;
              color: #9c3b00;
              line-height: 0.48rem;
            }

            .swiper-cnt {
              box-sizing: border-box;
              width: 5.9rem;
              height: 8.4rem;
              background: rgba(255, 255, 255, 0.6);
              border-radius: 0.24rem;
              margin-top: 0.16rem;
              position: relative;

              .swiper-equity {
                display: flex;
                align-items: center;
                margin: 0.28rem 0.4rem 0.16rem;

                .swiper-icon {
                  width: 0.4rem;
                  height: 0.4rem;
                }

                .swiper-text {
                  font-weight: 600;
                  font-size: 0.26rem;
                  color: #404040;
                  margin-left: 0.12rem;
                }
              }

              .swiper-desc {
                font-size: 0.24rem;
                color: rgba(0, 0, 0, 0.5);
                line-height: 0.4rem;
                margin: 0 0.4rem;
                position: relative;
                z-index: 1;
              }

              .swiper-img {
                width: 5.9rem;
                height: 3.2rem;
                position: absolute;
                bottom: 0;
              }
            }
          }
        }
      }
    }

    .other {
      background-color: #ffffff;
      border-top: 0.32rem solid #F5F5F5;

      .o-item {
        padding: 0rem 0.4rem;
      }

      .o-text {
        width: 100%;
        height: 1.2rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3a4961;
        line-height: 1.2rem;
        text-align: left;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          width: 0.44rem;
          height: 0.44rem;
          top: 0.4rem;
          right: 0;
          background: url("https://aistudyqiniu.knowbox.cn/fe/resources/img_1758184191091_37454.png") 0 0 / cover no-repeat;
        }
      }

      .line {
        height: 0.01rem;
        background: #EBEDF0;
      }

      .o-bottom {
        padding: 0.36rem 0.4rem 0.48rem 0.4rem;
        text-align: left;
        margin-bottom: 0.54rem;

        .text-bottom {
          font-size: 0.32rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #404040;
          line-height: 0.42rem;
        }

        .b-tip {
          margin-top: 0.1rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 0.34rem;

          &>span {
            color: #4ABCEF;
          }
        }
      }
    }

    .footer-zhan {
      height: 1.74rem;
    }
  }

  /deep/ .footer-container {
    position: relative;
    z-index: 2;

    .footer {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, #FFFFFF 100%);
      box-shadow: 0px -5 10px 0px rgba(0, 0, 0, 0.03), inset 0px 1 0px 0px #FFFFFF;
      border-radius: 0.4rem 0.4rem 0px 0px;
      backdrop-filter: blur(10px);
      height: 2.2rem;
    }

    .f-btn {
      margin: 0.4rem 0.32rem 0.14rem;
      background: linear-gradient(270deg, #FFC441 0%, #FFDA39 53%, #FFEE73 100%);
    }

    .f-text {
      span {
        color: #D57141;
      }
    }
  }

  .pop-content {
    padding: 0.4rem 0.32rem 1.76rem 0.32rem;

    .pop-title {
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #404040;
      line-height: 20px;
      margin-bottom: 0.16rem;
    }

    .pop-scroll {
      height: 4.32rem;
      overflow: auto;

      &>p {
        width: 4.64rem;
        font-weight: 400;
        font-size: 12px;
        color: #404040;
        line-height: 20px;
        text-align: left;
        margin-bottom: 0.18rem;
      }
    }

    .pop-footer {
      position: absolute;
      bottom: 0;
      height: 1.76rem;
      background-color: #ffffff;

      .know {
        margin-top: 0.48rem;
        width: 4.64rem;
        height: 0.88rem;
        background: linear-gradient(270deg, #FFC441 0%, #FFDA39 53%, #FFEE73 100%);
        border-radius: 16px;
        border: 0.02rem solid #FFF34D;
        font-weight: 1000;
        font-size: 0.32rem;
        color: #8D2E00;
        line-height: 20px;
        padding: 0.2rem 0.184rem 0.24rem 0.184rem;
      }
    }
  }

  .pop-suc {
    width: 5.72rem;
    height: 7.4rem;
    border-radius: 0.3rem;

    .pop-img {
      width: 5.72rem;
      height: 5.88rem;
      position: absolute;
      right: 0;
    }

    .pop-suc-title {
      margin-top: 0.48rem;
      font-size: 0.4rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1b2a42;
      line-height: 0.56rem;
    }

    .pop-text {
      margin-top: 0.24rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3a4961;
      line-height: 0.44rem;
    }

    .pop-begin {
      width: 4.64rem;
      height: 0.88rem;
      background: #ff6e45 linear-gradient(90deg, #ffdab1 0%, #fcb170 100%);
      border-radius: 0.44rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7a3104;
      line-height: 0.88rem;
      position: absolute;
      bottom: 0.1rem;
      right: 0.48rem;
    }
  }

  .share-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;
  }
}

/deep/ .suc-van-popup-container .van-popup {
  overflow-y: visible;
}

.suc-van-popup-container .van-popup {
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  background: none;
  -webkit-transition: -webkit-transform .3s;
  transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  -webkit-overflow-scrolling: touch;
}

.act20230901-dialog {
  width: 6rem;
  height: 6.32rem;
  background: #fff;
  border-radius: 0.32rem;

  .title {
    font-size: 0.4rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1B2A42;
    line-height: 0.56rem;
    margin: 0.48rem 0 0.24rem;
  }

  .bd {
    margin-bottom: 0.72rem;

    .coin {
      width: 2.64rem;
      height: 2.64rem;
    }

    .text {
      font-size: 0.28rem;
      font-family: PingFang SC;
      color: #1B2A42;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      /* line-height: 0.56rem; */
    }
  }

  .ft {
    .button {
      width: 5.04rem;
      height: 0.88rem;
      line-height: 0.88rem;
      text-align: center;
      background: linear-gradient(90deg, #FFDAB1 0%, #FCB170 100%);
      border-radius: 0.44rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7A3104;
      margin: 0 auto;
    }
  }

  .close {
    width: 0.44rem;
    height: 0.44rem;
    background: url(https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/close.png);
    background-size: cover;
    position: absolute;
    right: 0.16rem;
    top: 0.16rem;
  }
}

.equity-popup-container {
  background-color: transparent;
  height: 6.4rem;

  .equity-popup-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .equity-popup-img {
      width: 6.84rem;
      height: 2.88rem;
    }

    .equity-popup-btn {
      margin-top: -0.4rem;
      min-width: 4rem;
      height: 44px;
      background: linear-gradient(270deg, #FFC441 0%, #FFDA39 53%, #FFEE73 100%);
      border-radius: 16px;
      border: 0.02rem solid #FFF34D;
      font-weight: 1000;
      font-size: 16px;
      color: #8D2E00;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .equity-popup-close {
      position: absolute;
      width: 0.8rem;
      height: 0.8rem;
      bottom: -2.8rem;
    }
  }
}
.year-popup-container{
  background-color: transparent;
  // height: 6.4rem;

  .year-popup-wrap {
    display: flex;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    position: relative;

    .year-popup-bg {
      width: 100%;
      position: relative;
      // height: 2.88rem;
    }

    .year-popup-img {
      width: 6.84rem;
      position: absolute;
      top: 1rem;
      // height: 2.88rem;
    }

    .year-popup-btn {
      position: absolute;
      bottom: 2rem;
      min-width: 5rem;
      height: 52px;
      background: linear-gradient( 90deg, #FF7519 0%, #F9434D 52%, #FD3A95 100%);
      box-shadow: inset 0px -4px 0px 0px #FF1B2A;
      border-radius: 14px;
      font-weight: 1000;
      font-size: 20px;
      color: #fff;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      /* 扫光效果 */
      &::before {
        content: "";
        position: absolute;
        inset: -20%;
        background: linear-gradient(45deg,
            rgba(255, 255, 255, 0) 40%,
            rgba(255, 255, 255, 0.7),
            rgba(255, 255, 255, 0) 60%);
        animation: sweep 1.5s infinite;
      }

      /* 扫光动画定义 */
      @keyframes sweep {
        0% {
          left: -100%;
        }

        100% {
          left: 100%;
        }
      }
    }

    .year-popup-close {
      position: absolute;
      width: 0.8rem;
      height: 0.8rem;
      bottom: 0rem;
    }
  }
  
}
</style>
}
</style>
